import { styled } from "styled-components";
import { Button, MenuButton } from "capitalrx-components-2.0/lib/general";
import { SubmitButton, SubmitButtonProps } from "capitalrx-components-2.0/lib/forms";
import { FC, PropsWithChildren } from "react";

export const ThemedButton = styled(Button)<{$iconcolor?: string}>`
  &.tertiary {
    color: #61646c;
    &:hover {
      color: #61646c;
    }

    path {
      fill: ${(props) => props.$iconcolor ?? "#61646c"} !important;
    }

    &.disabled {
      color: #61646c !important;
      cursor: not-allowed;
    }
    &:disabled {
      color: #61646c !important;
      cursor: not-allowed;
    }

    &:active {
      color: #61646c !important;
    }
  }

  &.secondary {
    border-color: #61646c;
    color: #61646c;

    &:hover&:not(:disabled) {
      border-color: #61646c;
      color: #61646c;
      background-color: #61646C1A;
    }

    path {
      fill: ${(props) => props.$iconcolor ?? "#61646c"} !important;
    }

    &.disabled {
      border-color: #61646c !important;
      opacity: 0.5;
      color: #61646c !important;
    }
    &:disabled {
      border-color: #61646c !important;
      opacity: 0.5;
      color: #61646c !important;
    }
  }

  &.primary {
    border-color: #61646c;
    background-color: #61646c;
    &:hover {
      border-color: #61646c;
      background-color: #61646c;
    }

    &.disabled {
      background-color: #61646c !important;
      border-color: #61646c !important;
      opacity: 0.5;
    }
    &:disabled {
      background-color: #61646c !important;
      border-color: #61646c !important;
      opacity: 0.5;
    }
  }
`;

const _ThemedSubmitButtonWrapper = styled.div`
  > * {
    width: 100%;
  }

  > .disabled {
    background-color: #61646c !important;
    border-color: #61646c !important;
    opacity: 0.5;
  }
  > :disabled {
    background-color: #61646c !important;
    border-color: #61646c !important;
    opacity: 0.5;
  }

  > .tertiary {
    color: #61646c;
    &:hover {
      color: #61646c;
    }

    path {
      fill: #61646c !important;
    }
  }

  > .primary {
    border-color: #61646c;
    background-color: #61646c;
    &:hover,
    &:active {
      border-color: #61646c;
      background-color: #61646c;
    }
  }
`;

const _ThemedSubmitButton: FC<PropsWithChildren & SubmitButtonProps> = (props) => {
  return (
    <_ThemedSubmitButtonWrapper>
      <SubmitButton {...props}>{props.children}</SubmitButton>
    </_ThemedSubmitButtonWrapper>
  );
};

export const ThemedSubmitButton = _ThemedSubmitButton;

export const ThemedMenuButton = styled(MenuButton)`
  > button.primary, > button.primary.down {
    border-color: #61646c;
    background-color: #61646c;
    &:hover,
    &:active {
      border-color: #61646c;
      background-color: #61646c;
    }
  }

  > button.tertiary, button.tertiary.down {
    color: #61646c;
    &:hover {
      color: #61646c;
    }

    path {
      fill: #61646c;
    }
  }
`;

